/**
 * Tour — registro central de alvos.
 *
 * As telas marcam elementos com `ref={alvoTour('id')}`; o overlay pergunta
 * aqui onde cada alvo está. Ref de callback: monta registra, desmonta limpa —
 * nada de querySelector espalhado nem id mágico no DOM.
 */
const alvos = new Map();

// cache de callbacks: `ref={alvoTour('x')}` em toda render devolve a MESMA
// função, senão o React desregistra/re-registra o ref a cada render.
const callbacks = new Map();

export function alvoTour(id) {
  if (!callbacks.has(id)) {
    callbacks.set(id, (el) => {
      if (el) alvos.set(id, el);
      else alvos.delete(id);
    });
  }
  return callbacks.get(id);
}

export function obterAlvo(id) {
  return alvos.get(id) || null;
}
